import { useState } from "react";
import { Button } from "../../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../components/ui/dialog";

import { Label } from "../../../components/ui/label";

import { Edit2Icon } from "lucide-react";
import { Input } from "../../../components/ui/input";


export function EditStocksOptionsModal({
  rowData,
  handleEditStockOptionsConfig,
}) {
  const [open, setOpen] = useState(false);
  const [stocksMultiplier, setStocksMultiplier] = useState(rowData?.multiplier);
  const [stocksConfig, setStocksConfig] = useState({
    PDI_MA: rowData?.PDI_MA,
    PDI_MDI: rowData?.PDI_MDI,
    HHPC_PCL2: rowData?.HHPC_PCL2,
    HHPC_PCL5: rowData?.HHPC_PCL5,
    HE: rowData?.HE,
  });

  const handleEdit = () => {
    handleEditStockOptionsConfig(
      rowData.client_id,
      Number(stocksMultiplier),
      stocksConfig
    );

    setOpen(false);
  };

  const handleChange = (key, value) => {
    setStocksConfig((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="bg-zinc-800 text-white px-2.5 hover:bg-zinc-700  rounded-[5px]">
          <Edit2Icon className="w-4 h-4 " />
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[725px] border-zinc-700">
        <DialogHeader>
          <DialogTitle className="text-white">
            Edit Stocks Options Multiplier
          </DialogTitle>
        </DialogHeader>

        <div className="grid grid-cols-3 gap-4 py-4">
          <div className="grid grid-cols-1 items-center gap-4">
            <Label className=" text-white">Stock Multiplier</Label>
            <Input
              type="number"
              placeholder="Enter Muliplier"
              className="text-white"
              value={stocksMultiplier}
              onChange={(e) => setStocksMultiplier(e.target.value)}
            />
          </div>
          {Object.keys(stocksConfig)
            .filter((key) => key !== "clientId")
            .map((key) => (
              <div key={key} className="grid grid-cols-1 items-center gap-4">
                <Label className="text-white">{key.toUpperCase()}</Label>
                <Input
                  type="number"
                  placeholder={`Enter ${key}`}
                  className="text-white"
                  value={stocksConfig[key]}
                  onChange={(e) => handleChange(key, e.target.value)}
                />
              </div>
            ))}
        </div>
        <DialogFooter>
          <Button
            type="submit"
            className="text-[16px] font-normal bg-zinc-800 text-white hover:bg-zinc-700"
            onClick={handleEdit}
          >
            Update Multiplier
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
